export const submissionsLogsHeader = [
  {
    name: 'sr',
    isSelected: true,
    displayName: 'table_header_id',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'indexed',
  },
  {
    name: '',
    isSelected: true,
    displayName: 'table_header_message',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    translateVal: true,
    populateFunc: 'populateSubmissionLogMessage',
    callbackFunc: 'callbackSubmissionLogMessage',
  },
  {
    name: '',
    isSelected: true,
    displayName: 'table_header_recipient',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'recipient',
  },
  {
    name: '',
    isSelected: true,
    displayName: 'table_header_message_respond',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    translateVal: true,
    associatedKey: 'messageResponse',
    populateFunc: 'populateSubmissionLogRespondText',
  },
  {
    name: '',
    isSelected: true,
    displayName: 'table_header_type',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'logType',
    translateVal: true,
    populateFunc: 'populateSubmissionLogType',
  },
  {
    name: '',
    isSelected: true,
    displayName: 'table_header_status',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    translateVal: true,
    associatedKey: 'messageStatus',
    populateFunc: 'populateSubmissionLogStatus',
  },
  {
    name: '',
    isSelected: true,
    displayName: 'table_header_auto_accept',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    translateVal: true,
    associatedKey: 'autoAccepted',
    populateFunc: 'populateSubmissionLogAutoAccept',
  },
  {
    name: '',
    isSelected: true,
    displayName: 'table_header_reject_reason',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    translateVal: true,
    populateFunc: 'populateSubmissionLogRejectReason',
    callbackFunc: 'callbackSubmissionLogMessage',
  },
  {
    name: '',
    isSelected: true,
    displayName: 'table_header_date_and_time',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'createdAt',
    populateFunc: 'populateDateTime',
  },
];

export const submissionsHeader = [
  {
    name: 'sr',
    isSelected: true,
    displayName: '#',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'indexed',
  },
  {
    name: 'referenceNumber',
    isSelected: true,
    displayName: 'table_header_reference_number',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'referenceNumber',
  },
  {
    name: 'userName',
    isSelected: true,
    displayName: 'table_header_user_name',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    populateFunc: 'databaseUpdatedBy',
  },
  {
    name: 'submitted',
    isSelected: true,
    displayName: 'table_header_date_submitted',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'createdAtTime',
    populateFunc: 'populateDateTimeForSubmission',
  },
  {
    name: 'submissionFlowState',
    isSelected: true,
    displayName: 'table_header_form_status',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    translateVal: true,
    associatedKey: 'submissionFlowState',
    populateFunc: 'populateSubmissionFlowState',
  },
  {
    name: 'webView',
    isSelected: true,
    displayName: 'table_header_web_view',
    isFilterAble: false,
    type: 'webView',
    tableType: 'user',
    // associatedKey: 'webView',
    populateFunc: 'populateWebViewIcon',
    callbackFunc: 'gotoRecordPreviewPage',
  },
  {
    name: 'comments',
    isSelected: true,
    displayName: 'table_header_comments',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    populateFunc: 'populateCommentsIcon',
    callbackFunc: 'commentCallback',
  },
  {
    name: 'viewLogs',
    isSelected: true,
    displayName: 'table_header_view_logs',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    // associatedKey: '',
    populateFunc: 'populateViewLogs',
    callbackFunc: 'preViewLogs',
  },
];

export const stringOperators = [
  { value: 'equal', displayValue: 'Equal' },
  { value: 'not_equal', displayValue: 'Not Equal' },
  { value: 'contains', displayValue: 'Contains' },
  // { value: 'starts_with', displayValue: 'StartsWith' },
  // { value: 'ends_with', displayValue: 'EndsWith' },
];
export const numberOperators = [
  { value: 'equal', displayValue: 'Equals' },
  { value: 'not_equal', displayValue: 'NotEquals' },
  { value: 'greater_than', displayValue: 'Greater Than' },
  { value: 'greater_than_equal_to', displayValue: 'GreaterThanEqualTo' },
  { value: 'less_than', displayValue: 'LessThan' },
  { value: 'less_than_equal_to', displayValue: 'LessThanEqualTo' },
];
export const singleChoiceOperators = [
  { value: 'equal', displayValue: 'Equals' },
  { value: 'not_equal', displayValue: 'NotEquals' },
];
export const multiChoiceOperators = [
  { value: 'in_array', displayValue: 'In Array' },
  { value: 'not_in_array', displayValue: 'Not In Array' },
];
export const conditionOperators = [
  { value: 'op_and', displayValue: 'AND' },
  { value: 'op_or', displayValue: 'OR' },
];

export async function imageUrlToBase64(imageUrl) {
  const response = await fetch(imageUrl);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result); // This is the base64 string (data URL)
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// store both child and parent properties of all fields in single object
export const amendFieldIdentities = (fieldIdentitiesObj, field, fieldTitle) => {
  if (field.elementType === 'checkList' || field.elementType === 'response') {
    const { triggers } = field;
    const { elementGlobalId } = field;
    for (const level1Key in triggers) {
      for (const level2Key in triggers[level1Key]) {
        for (const t of triggers[level1Key][level2Key]) {
          if (t.type === 'ask_a_question') {
            fieldIdentitiesObj[t.elementGlobalId] = {
              parentId: elementGlobalId,
              parentTitle: fieldTitle,
              check: level1Key,
              value: level2Key,
            };
          }
        }
      }
    }
  }
};

export const listManagerSectionPermissions = (
  allManagerSectionElements,
  managerSectionPermissions,
  currentUserRole,
  currentUserId,
) => {
  const userMangerSectionPermissions = [];
  // Owner is allowed to edit all sections
  if (currentUserRole === 'owner') {
    allManagerSectionElements.forEach((section) => {
      userMangerSectionPermissions.push({
        managerSectionGlobalId: section.elementGlobalId,
        accessLevel: 'full_access',
      });
    });
  } else {
    managerSectionPermissions.forEach((sectionPermission) => {
      (sectionPermission.users ?? []).forEach((user) => {
        if (user.userId === currentUserId) {
          userMangerSectionPermissions.push({
            managerSectionGlobalId: sectionPermission.managerSectionGlobalId,
            accessLevel: user.accessLevel,
          });
        }
      });

      (sectionPermission.groups ?? []).forEach((group) => {
        if (group.groupId?.users.includes(currentUserId)) {
          userMangerSectionPermissions.push({
            managerSectionGlobalId: sectionPermission.managerSectionGlobalId,
            accessLevel: group.accessLevel,
          });
        }
      });
    });
  }

  return userMangerSectionPermissions;
};

export const isShowField = (formValues, field) => {
  const { fieldIdentitiesObj } = field;
  const { parentId, check, value } = fieldIdentitiesObj?.[field.name] || {};
  if (!parentId) return true;
  const parentValue = formValues[parentId];
  if (
    parentValue?.length > 0 &&
    ((check === 'is' && value === parentValue) || (check === 'is_not' && value !== parentValue))
  ) {
    const grandParentId = fieldIdentitiesObj[parentId]?.parentId;
    if (grandParentId) {
      const grandParentCurrentValue = formValues[grandParentId];
      if (grandParentCurrentValue?.length > 0) {
        const grandParentCheck = fieldIdentitiesObj[parentId]?.check;
        const grandParentValue = fieldIdentitiesObj[parentId]?.value;
        if (
          (grandParentCheck === 'is' && grandParentValue === grandParentCurrentValue) ||
          (grandParentCheck === 'is_not' && grandParentValue !== grandParentCurrentValue)
        ) {
          return true;
        }
      }
      return false;
    }
    return true;
  }
  return false;
};

export const submissionRecipientHeaderList = [
  {
    name: 'name',
    displayName: 'table_header_name',
    mandatory: true,
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'name',
  },
  {
    name: 'email',
    displayName: 'table_header_email',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'email',
  },
  {
    name: 'mobileNumber',
    displayName: 'table_header_sms_and_whatsapp',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateMobileNumberWithCountryCode',
  },
  {
    name: 'channels',
    displayName: 'table_header_channels',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateSubmissionChannel',
    callbackFunc: 'submissionChannelCallback',
  },
  {
    name: 'pdfTemplate',
    displayName: 'table_header_pdf_template',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateCustomTemplate',
    callbackFunc: 'templateDetails',
  },
  {
    name: '',
    displayName: '',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateCrossIcon',
    callbackFunc: 'deleteRowCallback',
  },
];
